// document.addEventListener('DOMContentLoaded', () => {

//   const imageContainer = document.querySelectorAll('.image-container');

//   if (imageContainer) {
//     imageContainer.forEach(container => {
//       container.addEventListener('click', () => {
//         container.querySelector('.fullscreen-image').classList.toggle('fullscreen');
//       });
//     });
//   }




//     var observer = new IntersectionObserver(function (entries) {
//         entries.forEach(function (entry) {
//             if (entry.isIntersecting) {
//                 entry.target.classList.add('visible');
//             }
//         });
//     }, { threshold: 0.5 });

//     var animatedImages = document.querySelectorAll('.scroll-animation');
//     animatedImages.forEach(function (img) {
//         observer.observe(img);
//     });


// });

